import React from "react";

import { IntlShape } from "react-intl";

import { Group } from "@mapmycustomers/shared/types/entity";

import EntityTag from "../../EntityTag";

import styles from "./DaysOverCadence.module.scss";

interface Props {
  group: Group;
  // This component is a part of the table columns and thus is not a part of the component ancestry
  // This is what react says, but this looks wrong to me (there are other components which are also
  // used in column renders, but are good with useIntl). However I don't have enough time to
  // investigate this now, so keeping this workaround :(
  // Btw, this can be a result of using this component inside <LongContentParagraph>. Something
  // connected to how AntD processes "ellipsis" in their long paragraphs.
  intl: IntlShape;
}

const DaysOverCadence: React.FC<Props> = ({ group, intl }) => {
  return (
    <EntityTag className={styles.tag} entity={group}>
      {intl.formatMessage(
        {
          id: "component.cadenceDaysOut",
          defaultMessage:
            "{name}: {hadContact, select, true {{daysOut} {daysOut, plural, one {day over} other {days over}}} other {Not yet contacted}}",
          description: "Days out for the given group on the Reports page",
        },
        {
          daysOut: group.cadenceDaysOut,
          hadContact: group.cadenceDaysOut && group.cadenceDaysOut > 0,
          name: group.name,
        }
      )}
    </EntityTag>
  );
};

export default DaysOverCadence;
